import { getLocalitesHandler } from './overrides/getLocalitesHandler'

export const handlers = [
  getLocalitesHandler(),
]
